import { media, styled } from '@styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  ${media.largeScreen`
    margin-top: 40px;
  `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 26px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-left: 5px;
  ${media.largeScreen`
    padding-bottom: 20px;
  `}

  .filter-reset {
    display: inline-block;
    margin-left: auto;
    ${media.smallScreen`
      display: none;
    `}
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  font-weight: 300;
  font-size: ${(props) => props.theme.typography.baseFontSize};
  line-height: ${(props) => props.theme.typography.baseFontSize};
  color: #839098;
  margin-right: 70px;
  cursor: pointer;
  transition-property: color;
  transition-duration: 0.3s;
  padding-left: 4px;
  position: relative;
  ${media.largeScreen`
    margin-right: 50px;
  `}
  ${media.smallScreen`
    margin-right: 35px;
  `}
  .dropdown-arrow {
    display: flex;
    align-items: center;
    margin-left: 14px;
    margin-top: 7px;
    transition-property: transform;
    transition-duration: 0.3s;
    ${media.largeScreen`
      margin-left: 17px;
    `}
    > div {
      display: flex;
      align-items: center;
    }
    path {
      transition-property: stroke, opacity;
      transition-duration: 0.3s;
    }
  }
  &.active {
    color: #c34c3e;
    .dropdown-arrow {
      transform: rotateX(180deg);
      path {
        stroke: #c34c3e;
        opacity: 1;
      }
    }
  }
  &.selected {
    &::before {
      content: '';
      display: inline-block;
      width: 5px;
      height: 5px;
      background-color: #ca9c66;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: -4px;
    }
  }
  &.no-margin {
    margin-right: 0;
  }
`;

export const Body = styled.div`
  &.category {
    padding-top: 34px;
    padding-bottom: 23px;
    ${media.largeScreen`
      padding-top: 30px;
      padding-bottom: 10px;
    `}
    ${media.smallScreen`
      padding-top: 24px;
      padding-bottom: 0;
    `}
  }
  &.color {
    padding-top: 32px;
    padding-bottom: 20px;
    ${media.largeScreen`
      padding-top: 20px;
      padding-bottom: 15px;
    `}
    ${media.smallScreen`
      padding-top: 24px;
      padding-bottom: 0;
    `}
  }
  &.width {
    padding-top: 38px;
    padding-bottom: 15px;
    max-width: 600px;
    ${media.largeScreen`
      padding-top: 21px;
      padding-bottom: 10px;
    `}
    ${media.mediumScreen`
      padding-top: 40px;
      padding-bottom: 20px;
    `}
    ${media.smallScreen`
      padding-top: 24px;
      padding-bottom: 0;
    `}
  }
  &.tag {
    padding-top: 20px;
    padding-bottom: 15px;
    ${media.largeScreen`
      padding-top: 14px;
      padding-bottom: 10px;
    `}
    ${media.mediumScreen`
      padding-top: 30px;
      padding-bottom: 20px;
    `}
    ${media.smallScreen`
      padding-top: 24px;
      padding-bottom: 0;
    `}
  }
`;

export const ResetButton = styled.div`
  margin-left: auto;
  font-size: ${(props) => props.theme.typography.baseFontSize};
  line-height: ${(props) => props.theme.typography.baseFontSize};
  color: #bdbdbd;
  cursor: pointer;
  display: none;
  ${media.smallScreen`
    display: inline-block;
    margin: 30px auto 0;
  `}
`;
